import React from 'react';
import PageForm from "components/pageForm/PageForm";
import Usefetchdata from "hooks/usefetchdata";

const AdminProfil = () => {
    const { userData } = Usefetchdata();

    // Format date de naissance
    const formatBirthday = (birthday) => {
        if (!birthday) return '-';
        const date = new Date(birthday);
        if (isNaN(date.getTime())) return birthday;
        return date.toLocaleDateString('fr-FR', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric'
        });
    };

    return (
        <PageForm>
            <div className="w-full px-2 tab:px-4 lg:px-8 py-8 mb-28 flex flex-col gap-8">

                <div className="w-full bg-white ">
                    <div className="flex flex-col gap-6 max-w-2xl">
                        <h2 className="text-xl font-medium text-gray-900">Informations du compte</h2>
                        
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                            <div className="flex flex-col gap-1">
                                <label className="text-xs font-medium text-gray-500 uppercase tracking-wide">
                                    Prénom
                                </label>
                                <input 
                                    type="text"
                                    disabled
                                    value={userData?.firstname || ''}
                                    className="w-full h-10 pl-3 pr-8 text-sm bg-gray-100 border border-gray-200 rounded-lg text-gray-900"
                                />
                            </div>
                            <div className="flex flex-col gap-1">
                                <label className="text-xs font-medium text-gray-500 uppercase tracking-wide">
                                    Nom
                                </label>
                                <input 
                                    type="text"
                                    disabled
                                    value={userData?.lastname || ''}
                                    className="w-full h-10 pl-3 pr-8 text-sm bg-gray-100 border border-gray-200 rounded-lg text-gray-900"
                                />
                            </div>
                        </div>

                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                            <div className="flex flex-col gap-1">
                                <label className="text-xs font-medium text-gray-500 uppercase tracking-wide">
                                    E-mail
                                </label>
                                <input 
                                    type="text"
                                    disabled
                                    value={userData?.email || ''}
                                    className="w-full h-10 pl-3 pr-8 text-sm bg-gray-100 border border-gray-200 rounded-lg text-gray-900"
                                />
                            </div>
                            <div className="flex flex-col gap-1">
                                <label className="text-xs font-medium text-gray-500 uppercase tracking-wide">
                                    Date de naissance
                                </label>
                                <input 
                                    type="text"
                                    disabled
                                    value={formatBirthday(userData?.birthday)}
                                    className="w-full h-10 pl-3 pr-8 text-sm bg-gray-100 border border-gray-200 rounded-lg text-gray-900"
                                />
                            </div>
                        </div>

                        <div className="flex flex-col gap-1">
                            <label className="text-xs font-medium text-gray-500 uppercase tracking-wide">
                                Rôle
                            </label>
                            <input 
                                type="text"
                                disabled
                                value={userData?.role === 500 ? 'Admin' : userData?.role === 515 ? 'Collaborateur' : 'Utilisateur'}
                                className="w-full max-w-xs h-10 pl-3 pr-8 text-sm bg-gray-100 border border-gray-200 rounded-lg text-gray-900"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </PageForm>
    );
};

export default AdminProfil;
